import React, { Component } from 'react';
import ld_orderBy from 'lodash/orderBy';
import ld_filter from 'lodash/filter';

import FormSearch from './FormSearch';
import FormTags from './FormTags';
import ProductGrid from './ProductGrid';

require('smoothscroll-polyfill').polyfill();

class App extends Component {
   constructor(props) {
      super(props);
      this.state = {
         productCollection: [],
         renderCollection:[],
         sortInfo: ["none", "none"],
         filterText: "",
         filterTag: "none",
      };

      this.handleFilterTextInput = this.handleFilterTextInput.bind(this);
      this.handleFilterTag = this.handleFilterTag.bind(this);
      this.handleSort = this.handleSort.bind(this);
   }

   /*****************************************/
   /* FUNCTION */
   /*****************************************/
   setFilterTag(lastTag) {
      return (this.state.filterTag === lastTag) ? "none" : lastTag
   }

   setSortInfo(lastChoice) {
      let newSortInfo = []
      if (this.state.sortInfo[0] === lastChoice) {
         if(this.state.sortInfo[1] === "desc") {
            newSortInfo = [lastChoice, "asc"]
         } else {
            newSortInfo = ["none", "none"]
         }
      } else {
         newSortInfo = [lastChoice, "desc"]
      }
      return newSortInfo
   }

   getProductCollection() {
      //const url = "http://beta.json-generator.com/api/json/get/NJFtjuQX7"
      const url = "data/product.json" /* si erreur 502 sur le serveur */
      fetch(url)
      .then((resp) => resp.json())
      .then((data) => {
         this.setState({
            productCollection:data,
            renderCollection:data
         })
      })
      .catch((error) => {
         console.log('fetch failed: ' + error.message);
      })
   };

   filterCollection(sortInfo, filterTag, filterText) {
      /* 1 - Ordonne la collection */
      let orderCollection = []
      if (sortInfo[1] === "none") {
         orderCollection = this.state.productCollection
      } else {
         orderCollection = ld_orderBy(this.state.productCollection, [sortInfo[0]], [sortInfo[1]]);
      }
      /* 2 - Filtre avec les tags */
      let filterTagCollection = []
      if (filterTag === "none") {
         filterTagCollection = orderCollection
      } else {
         filterTagCollection = ld_filter(orderCollection, filterTag);
      }
      /* 3 - Filtre sur le nom */
      let filterTextCollection = []
      if (filterText === "") {
         filterTextCollection = filterTagCollection
      } else {
         filterTextCollection = filterTagCollection.filter(function (product) {
            return product.nom.indexOf(filterText) !== -1;
         });
      }
      return filterTextCollection
   }

   /*****************************************/
   /* HANDLE */
   /*****************************************/
   handleSort(lastChoice) {
      const newSortInfo = this.setSortInfo(lastChoice)
      this.setState({sortInfo:newSortInfo})
      this.setState({renderCollection:this.filterCollection(newSortInfo, this.state.filterTag, this.state.filterText)})
   }

   handleFilterTag(filterTag) {
      const newFiltertag = this.setFilterTag(filterTag)
      this.setState({filterTag:newFiltertag})
      this.setState({renderCollection:this.filterCollection(this.state.sortInfo, newFiltertag, this.state.filterText)})
   }

   handleFilterTextInput(filterText) {
      const newFilterText = filterText.toUpperCase()
      this.setState({filterText:newFilterText})
      this.setState({renderCollection:this.filterCollection(this.state.sortInfo, this.state.filterTag, newFilterText)})
   }

   /*****************************************/
   /* EVENT */
   /*****************************************/
   componentDidMount() {
      this.getProductCollection()
   }

   /*****************************************/
   /* RENDER */
   /*****************************************/
   render() {
      const count = this.state.renderCollection.length
      console.log(count)

      return (
         <div>
            <div className="visible-xs-block">
               <FormTags
                  count={count}
                  filterTag={this.state.filterTag}
                  onFilterTag={this.handleFilterTag} />
            </div>
            <div className="page">
               <div className="sidebar hidden-xs">
                  <FormTags
                     count={count}
                     filterTag={this.state.filterTag}
                     onFilterTag={this.handleFilterTag} />
               </div>
               <div className="content">
                  <div className="container-fluid">
                     <div className="push-sm"></div>
                     <FormSearch
                        sortInfo={this.state.sortInfo}
                        filterTag={this.state.filterTag}
                        onFilterTextInput={this.handleFilterTextInput}
                        onFilterTag={this.handleFilterTag}
                        onSort={this.handleSort}
                        />
                     <ProductGrid
                        sortInfo={this.state.sortInfo}
                        filterTag={this.state.filterTag}
                        filterText={this.state.filterText}
                        productFilteredCollection={this.state.renderCollection}
                        />
                     <div className="push"></div>
                  </div>

               </div>
            </div>
         </div>
      );
   }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js